// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CurrenciesList_contentComponent__1J_dQ","tableContainer":"CurrenciesList_tableContainer__1bzz8"};